import React from "react";
import LoginPageSectoin from "../../Sections/LoginPageSection/Content";
const LandingPage = () => {
  return <LoginPageSectoin />;
};

export default LandingPage;
